module.exports = {
  "country": "IT",
  "artist": "Francesco Gabbani",
  "song": "Occidentali's Karma",
  "year": "2017",
  "place": "6",
  "spotify": "7nBGd4jSPgvdJn97sdrFK5"
};